import { DatePicker } from "antd";
import { PickerProps } from "antd/es/date-picker/generatePicker";
import { Dayjs } from "dayjs";
interface InputDateProps
  extends Omit<
    PickerProps<Dayjs>,
    "onChange" | "value" | "defaultValue" | "onOk"
  > {
  placeholder: string;
  onChange?: (value: Dayjs | null) => void;
  value?: Dayjs | null;
  class?: any;
}
const InputDate = ({ ...props }: InputDateProps) => {
  const handleChange = (date: any) => {
    if (props.onChange) {
      props.onChange(date);
    }
  };
  return (
    <div className={`takaful--input-date-container ${props.class ?? ""}`}>
      <DatePicker
        {...props}
        size="large"
        value={props.value}
        onChange={handleChange}
        placeholder={props.placeholder}
        format={"YYYY/MM/DD"}
        className={`takaful--input takaful--input-date ${
          props.className ?? ""
        }`}
      />
    </div>
  );
};

export default InputDate;
